import React from 'react';
import { MapPinIcon, StarIcon } from 'lucide-react';
import { Section } from './Section';
import { deepQuotes } from '../data/content';
export function Testimonials() {
  return <Section tone="white" eyebrow="Testimonios" title="Historias reales de impacto" data-id="element-158" data-mp="3fznrfeogiyy7">
      <ul className="mx-auto max-w-narrow divide-y divide-gray-200" data-id="element-159" data-mp="3fxb4so7r80et">
        {deepQuotes.map(quote => <li key={`${quote.author}-${quote.city}`} className="grid gap-4 py-8 first:pt-0 last:pb-0 md:grid-cols-[minmax(0,14rem)_1fr] md:gap-10" data-id="element-160" data-mp="36yzgwty9vgq2">
            <div className="flex items-start gap-3" data-id="element-161" data-mp="321z6k6ue3rt5">
              <span className="flex h-11 w-11 shrink-0 items-center justify-center rounded-full bg-night font-display text-xs font-bold text-amber-400" data-id="element-162" data-mp="2x1upaelnqt1v">
                {quote.initials}
              </span>
              <span data-id="element-163" data-mp="v8591v8ft91q">
                <span className="flex gap-0.5" aria-label="5 de 5 estrellas" data-id="element-164" data-mp="v8ncbbtionj5">
                  {Array.from({
                length: 5
              }).map((_, index) => <StarIcon key={index} className="h-4 w-4 fill-amber-400 text-amber-400" aria-hidden="true" data-id="element-165" data-mp="h5f19rwoi73u" data-mpi={index} />)}
                </span>
                <span className="mt-1.5 block font-display font-extrabold tracking-tight text-night" data-id="element-166" data-mp="79bozt844s36">
                  {quote.author}
                </span>
                <span className="block text-sm text-gray-500" data-id="element-167" data-mp="zvwf6qcuqy55">{quote.role}</span>
                <span className="inline-flex items-center gap-1 text-sm text-gray-500" data-id="element-168" data-mp="14vj1rqeklqqm">
                  <MapPinIcon className="h-3.5 w-3.5" aria-hidden="true" data-id="element-169" data-mp="14xdckbw4o2gz" />
                  {quote.city}
                </span>
              </span>
            </div>
            <blockquote className="text-lg leading-relaxed text-ink md:text-xl" data-id="element-170" data-mp="v44x747ri0qm">
              “{quote.quote}”
            </blockquote>
          </li>)}
      </ul>
    </Section>;
}